// utils/date.js

/**
 * Formate une Date en YYYY-MM-DD (heure locale)
 * @param {Date} date - Un objet Date valide
 * @returns {string} La date formatée en YYYY-MM-DD
 */
export function formatDateToYYYYMMDD(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // mois de 0 à 11
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

/**
 * Parse une date YYYY-MM-DD en Date à minuit heure locale
 * (new Date('YYYY-MM-DD') donne minuit UTC, soit la veille à l'ouest d'UTC)
 * @param {string} str - La date au format YYYY-MM-DD
 * @returns {Date}
 */
export function parseYYYYMMDD(str) {
  const [year, month, day] = str.split('-').map(Number);
  return new Date(year, month - 1, day);
}
